import React, { useState } from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';

function SectionNameDialog({ title, initialName = '', submitLabel, onSubmit, onClose }) {
  const [name, setName] = useState(initialName);
  const { run, saving, error } = useDialogMutation();
  const trimmed = name.trim();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!trimmed || saving) return;
    await run(() => onSubmit(trimmed), onClose);
  };

  return (
    <Dialog title={title} onClose={onClose} locked={saving}>
      <form onSubmit={handleSubmit}>
        <label className="dialog-label" htmlFor="section-name">Section name</label>
        <input
          id="section-name"
          className="dialog-input"
          value={name}
          maxLength={40}
          autoFocus
          disabled={saving}
          onChange={(event) => setName(event.target.value)}
        />
        {error && <p className="dialog-error" role="alert">{error}</p>}
        <div className="dialog-actions">
          <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={!trimmed || saving}>
            {submitLabel}
          </button>
        </div>
      </form>
    </Dialog>
  );
}

export default SectionNameDialog;